
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.115 8.533l.707 1.645h6.631V3.934c0-.829-.697-1.5-1.555-1.5H5.957c-.857 0-1.555.67-1.555 1.5v3.964H8.13c.424-.005.812.245.986.635zM7.19 5.253c0-.267.22-.485.487-.485h5.508c.267 0 .486.218.486.486a.488.488 0 01-.486.486H7.676a.485.485 0 01-.487-.486z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.957 10.924H9.48l-.707-1.705c-.166-.4-.552-.66-.988-.66H2.96c-.59 0-1.068.478-1.068 1.068v2.234c0 .032.002.065.005.096-.001.031-.005.064-.005.096v5.443a1.135 1.135 0 001.134 1.135h13.93a1.135 1.135 0 001.135-1.135v-5.44c0-.3-.12-.59-.332-.802a1.144 1.144 0 00-.801-.33zM4.516 15.037a1.328 1.328 0 01-.938-2.268 1.33 1.33 0 11.938 2.268z","fill":"currentColor"}})])
          )
        }
      }
    